"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchView = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SearchView = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .search-wrapper {\n    border-radius: 2px;\n    margin-bottom: 1.25rem;\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n  }\n\n  .search-icon {\n    margin: 0.75rem;\n    color: rgba(0, 0, 0, 0.24);\n  }\n\n  .chip-wrapper {\n    flex-shrink: 0;\n    line-height: 1.5;\n    margin-right: 0.8rem;\n  }\n\n  .autocomplete {\n    flex-grow: 1;\n    padding-top: 13px;\n    padding-bottom: 13px;\n  }\n\n  .search-input {\n    border: 0;\n    width: 100%;\n    height: 100%;\n    padding: 0.25rem;\n    background-color: white;\n    width: 100%;\n  }\n\n  .mui-input-wrapper {\n    width: 100%;\n  }\n\n  .MuiInputBase-input {\n    padding: 6px 0 6px;\n  }\n\n  .search-input-group {\n    border: 0;\n    width: 100%;\n    height: 100%;\n    padding: 0.25rem;\n  }\n  \n  .chip {\n    background-color: ", ";\n    color: ", ";\n    border-radius: 100px;\n    height: 80%;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    font-size: 16px;\n    margin: 0 0.8rem 0 0;\n\n    .MuiChip-labelSmall {\n      font-size: 14px;\n    }\n\n    .MuiChip-deleteIcon {\n      margin: 3px 6px 2px 0px;\n    }\n  }\n\n  .MuiChip-deleteIcon {\n    margin-top: 2px;\n  }\n"])), function (_ref) {
  var children = _ref.children;
  return children.props.backgroundcolor;
}, function (_ref2) {
  var children = _ref2.children;
  return children.props.chipBackgroundColor;
}, function (_ref3) {
  var children = _ref3.children;
  return children.props.chipColor;
});

exports.SearchView = SearchView;

//# sourceMappingURL=SearchBar.style.js.map